export class StudentLaptopRequestModel {
	is_complete: boolean;
	is_waived: boolean;
	advocate_uid: number;
}
